import { h, Component } from 'preact';

import './index.less';
import { getCompanyId, getCompanyName } from '../../../lib/Company';
import {
  doesLogoExists,
  getLogoVersion,
  getCatalogueTheme,
  getLogoHeight,
  getLogoWidth,
  getLogoAspectRatio
} from '../../../lib/Amalgam';
import {
  getAllCatalogueIds,
  getHomePageHeadline,
  isHomePage,
  shouldRemoveCatalogueCount,
  shouldRemoveGroupCompanyHeader
} from '../../../lib/GroupAmalgam';
import {
  shouldRemoveCompanyNameFromCatalogueHeader,
  shouldRemoveSingleCompanyHeader
} from '../../../lib/Experiments';
import { getAssetPath } from '../../../lib/Utils';
import I18n from '../../../lib/I18n';
import Banner from '../../../molecules/Banner';
import RenewalReminderCard from '../../RenewalReminderCard';
import { isGroupRoute, NAME as ROUTE_NAME, getCurrentRouteName } from '../../../lib/Route';
import BackButton from '../../../molecules/CommonBackButton';
import { NAVBAR_LOGO_HEIGHT } from '../../../../config';

class HeaderExpanded extends Component {
  componentDidMount () {
    this.props.onRender(this.header);
  }

  renderCompanyLogo = () => {
    const { homepageLink } = this.props;
    const logoExists = doesLogoExists();
    const logoVersion = getLogoVersion();
    const companyId = getCompanyId();
    const companyName = getCompanyName();
    const { pageTextColor = '#000' } = getCatalogueTheme() || {};
    const logoHeight = getLogoHeight();
    const logoWidth = getLogoWidth();
    const logoAspectRatio = getLogoAspectRatio();

    if (logoExists) {
      return (
        <div className={'logo-icon-container'}>
          <a
            target="_self"
            title={companyName ? `${companyName} logo` : 'logo'}
            href={homepageLink}
            class="logo-icon-link"
            style={{ color: pageTextColor }}
          >
            <img
              className="logo-icon"
              src={`https://d1h96izmtdkx5o.cloudfront.net/${companyId}.jpg?v=${logoVersion}`}
              alt={companyName ? `${companyName} logo` : 'logo'}
              height={logoHeight}
              width={logoWidth}
              style={{
                height: 2 * NAVBAR_LOGO_HEIGHT,
                width: 2 * logoAspectRatio * NAVBAR_LOGO_HEIGHT
              }}
            />
          </a>
        </div>
      );
    }

    return <img className="icon" src={getAssetPath('icon-shop.svg')} alt="Icon" />;
  };

  renderCompanyName = () => {
    const { homepageLink } = this.props;
    const companyName = getCompanyName();
    const { pageTextColor = '#000' } = getCatalogueTheme() || {};
    if (!companyName) {
      return null;
    }
    return (
      <a
        target="_self"
        title={companyName}
        href={homepageLink}
        className="companyName"
        style={{
          color: pageTextColor
        }}
      >
        <h1 style={{ margin: '0px' }}>{companyName}</h1>
      </a>
    );
  };

  renderBackButton () {
    const { showBackButtonInExpandedHeader = false, goBack } = this.props;

    if (!showBackButtonInExpandedHeader || typeof goBack !== 'function') {
      return null;
    }

    return (
      <div className="expanded-header-back-button">
        <BackButton showBackIcon={showBackButtonInExpandedHeader} goBack={goBack} />
      </div>
    );
  }

  render () {
    const currentRoute = getCurrentRouteName();
    const allCatalogueIds = getAllCatalogueIds();
    const removeCompanyHeader = isGroupRoute()
      ? shouldRemoveGroupCompanyHeader()
      : shouldRemoveSingleCompanyHeader();
    const homePageHeadline = getHomePageHeadline();
    const { showBanner } = this.props;
    const { homeGrid = {}, pageTextColor } = getCatalogueTheme() || {};

    return (
      <div
        ref={(element) => (this.header = element)}
        className="header-expanded-group-catalogue"
        style={{
          background: homeGrid.backgroundColor
        }}
      >
        {isGroupRoute() && <RenewalReminderCard />}

        {this.renderBackButton()}

        {this.renderCompanyLogo()}

        <div className="header-expanded-content">
          {(!removeCompanyHeader ||
            (!isGroupRoute() && !shouldRemoveCompanyNameFromCatalogueHeader())) &&
            this.renderCompanyName()}
          {currentRoute === ROUTE_NAME.GROUP &&
            allCatalogueIds.length > 0 &&
            !shouldRemoveCatalogueCount() && (
            <div
              className="catalogueCount"
              style={{
                color: pageTextColor
              }}
            >
              {I18n.t(allCatalogueIds.length === 1 ? 'GROUP_ITEM_COUNT' : 'GROUP_ITEMS_COUNT', {
                count: allCatalogueIds.length
              })}
            </div>
          )}
        </div>

        {currentRoute === ROUTE_NAME.GROUP &&
        allCatalogueIds.length === 0 &&
        !shouldRemoveCatalogueCount() ? (
            <div className="noCatalogue">{I18n.t('NO_CATALOGUES_PUBLISHED')}</div>
          ) : (
            <div />
          )}

        {isHomePage() && homePageHeadline ? (
          <div className="homePageHeadline">{homePageHeadline}</div>
        ) : (
          <div />
        )}

        {isGroupRoute(currentRoute) && showBanner && <Banner />}
      </div>
    );
  }
}

export default HeaderExpanded;
